import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlanningCreateForm } from "@/features/rh/planning/components/PlanningCreateForm";

export const Route = createFileRoute("/_app/rh/planning/create")({
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.CREATE),
  staticData: {
    title: "Nouvel élément de planning",
    icon: null,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.CREATE,
    module: "rh",
    showInTab: false,
    showInBreadcrumb: true,
  },
  component: PlanningCreateForm,
});
